import { apiLaravelClient } from '../utils/apiLaravelClient';

const secondaryBaseUrl = "/api/v0.1"

export function postActiveCall(data) {
	return apiLaravelClient.post(`${secondaryBaseUrl}/videoroom/activecall` , data , {headers : {
		Authorization : "parentAuth"
	}});
}

export function getActiveCallDetails(data) {
	return apiLaravelClient.post(`${secondaryBaseUrl}/videoroom/call/details` , data, {headers : {
		Authorization : "parentAuth"
	}});
}

export function getParticipants(data) {
	return apiLaravelClient.get(`${secondaryBaseUrl}/get/video-room/participants/` + data);
}

